// extracted by mini-css-extract-plugin
export default {"Blogs":"Blogs_Blogs__Nyblg","Header":"Blogs_Header__+TkLn","Breadcrumb":"Blogs_Breadcrumb__yBuNu","BlogsWrapper":"Blogs_BlogsWrapper__B5FZd"};